// extracted by mini-css-extract-plugin
export default {"tooltip_container":"Tooltip_tooltip_container__A6bh5","tooltip":"Tooltip_tooltip__JYGhJ","fadeIn":"Tooltip_fadeIn__hNgSU","arrow":"Tooltip_arrow__7+5Nr"};